import StyleOutlinedIcon from "@mui/icons-material/StyleOutlined";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import { FileRecord } from "@/shared/domain/files";
import { usePopupState } from "@/shared/hooks";

import { FileDetails } from "../FileDetails";

interface ViewFileDetailsButtonProps {
  fileRecord: FileRecord;
}

export function ViewFileDetailsButton({
  fileRecord,
}: ViewFileDetailsButtonProps) {
  const tagMetadataPopup = usePopupState();

  return (
    <>
      <RobotoTooltip title="View file details">
        <span>
          <RobotoIconButton
            eventName="FileDetailsClicked"
            onClick={() => tagMetadataPopup.open()}
            sx={{ padding: "0.5rem" }}
            size="small"
          >
            <StyleOutlinedIcon
              style={{
                width: "1.25rem",
                height: "1.25rem",
              }}
            />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
      <Dialog
        open={tagMetadataPopup.isOpen}
        fullWidth
        maxWidth={"md"}
        onClose={tagMetadataPopup.close}
      >
        <DialogTitle>File Details</DialogTitle>
        <DialogContent>
          <FileDetails fileRecord={fileRecord} />
        </DialogContent>
      </Dialog>
    </>
  );
}
